<template>
	<div class="qd-card">
		<div class="section-title">مرتب سازی</div>
		<div class="section-container">
			<div class="item-selector-section">
				<select class="qd-dropdown sort-item-dropdown" v-model="selectedItem">
					<option v-for="column in filteredColumns" :key="column.path" :value="column">
						{{ column.alias ? column.alias : column.titlePath }}
					</option>
				</select>
				<button @click="add()" style="margin-right: 10px" class="qd-button">افزودن</button>
			</div>
			<div class="sort-items-container">
				<div class="sort-items">
					<div v-for="(sort, index) in localDataSorts" :key="index" class="sort-item my-2" @drop="drop($event, sort)" @dragover.prevent @dragenter.prevent>
						<div class="data-section">
							<span class="drag-icon"><i class="fas fa-grip-lines" draggable="true" @dragstart="dragStart($event, sort)"></i></span>
							<div class="column-name">
								{{ sort.titlePath }}
							</div>
						</div>
						<div class="sort-direction" @click="sort.direction = sort.direction === 'asc' ? 'desc' : 'asc'">
							<i class="fas" :class="{ 'fa-arrow-up-wide-short': sort.direction === 'asc', 'fa-arrow-down-wide-short': sort.direction === 'desc' }"></i>
						</div>
						<div class="delete-btn" @click="remove(index)">
							<i class="fas fa-trash-can"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import { maxBy, sortBy } from 'lodash'
	export default {
		name: "Sorts",
		props: {
			columns: {
				type: Array,
				default: () => [],
			},
			modelValue: {
				type: Object,
			},
		},
		emits: ["update:modelValue"],
		data() {
			return {
				localDataSorts: [],
				selectedItem: null,
			}
		},
		watch: {
			localDataSorts: {
				deep: true,
				handler() {
					this.$emit("update:modelValue", this.localDataSorts)
				},
			},
		},
		computed: {
			filteredColumns() {
				let filteredColumns = this.columns.filter(
					(col) => this.localDataSorts.findIndex((x) => x.path == col.path) === -1
				)
				return filteredColumns
			},
			lastOrder() {
				let maxItem = maxBy(this.localDataSorts, 'order')
				return maxItem ? maxItem.order : 0
			}
		},
		mounted() {
			this.localDataSorts = [...this.modelValue]
		},
		methods: {
			remove(index) {
				this.localDataSorts.splice(index, 1)
			},
			edit(index) {
				this.selectedVariableItem = this.localDataSorts[index]
				this.variableVisible = true
			},
			sortItemsByOrder() {
				this.localDataSorts = sortBy(this.localDataSorts, ['order'])
			},
			add() {
				if (!this.selectedItem) return
				this.localDataSorts.push({
					id: Math.random().toString(32).slice(2, 8),
					titlePath: this.selectedItem.titlePath,
					path: this.selectedItem.path,
					direction: "asc",
					order: this.lastOrder + 1
				})
			},
			resolveModifyVariable(resolvedVariable) {
				if (resolvedVariable) {
					let itemIndex = this.localDataVariables.findIndex(
						(v) => v.key === resolvedVariable.key
					)
					if (itemIndex > -1)
						this.localDataVariables[itemIndex] = resolvedVariable
					else this.localDataVariables.push(resolvedVariable)
				}
				this.variableVisible = false
			},
			dragStart(e, sortItem) {
				e.stopPropagation()
				let sortItemElement = e.target.closest('.sort-item')
				e.dataTransfer.setData('itemSort', sortItem.order)
				e.dataTransfer.setDragImage(sortItemElement, e.layerX, e.layerY)
			},
			drop(e, sortItem) {
				e.preventDefault()
				let draggedItem = this.localDataSorts.find(item => item.order == e.dataTransfer.getData('itemSort'))

				let temp = draggedItem.order
				draggedItem.order = sortItem.order
				sortItem.order = temp

				this.sortItemsByOrder()
			}
		},
	}
</script>

<style></style>
